export var valuesPlaylistStateEnum = ["Assigned", "Started", "Finished", "UserFinished"];
/*

*/ 
//# sourceMappingURL=PlaylistStateEnum.js.map